import { put, takeLatest } from 'redux-saga/effects';
import { DocumentsAPI } from 'api/document/document-core';
import { apiToNormalized, taskCollection } from 'collections/tasks';
import { createDocSectionTask, createDocTask, updateDocTaskIdNameMap } from 'data/documents';
import { logger } from 'services';
function* createDocTaskManager(action) {
    const { payload } = action;
    try {
        const response = yield DocumentsAPI.createTask(payload.projectId, payload.documentId, {
            taskName: payload.taskName,
            taskDescription: payload.taskDescription
        }, {
            resourceSectionId: payload.resourceSectionId
        });
        taskCollection.push([
            response
        ]);
    } catch (error) {
        logger.error('createDocTaskManager failed', {
            error
        });
    }
}
export const watchCreateDocTasks = function*() {
    yield takeLatest(createDocTask.type, createDocTaskManager);
};
function* createDocSectionTaskManager(action) {
    const { payload } = action;
    const { updateLocalState } = payload;
    try {
        const response = yield DocumentsAPI.createSectionTask(payload.projectId, {
            taskName: payload.taskName,
            taskDescription: payload.taskDescriptionPostfix ? `<p></p>
          <blockquote>
            <p> ${payload.taskDescriptionPostfix}</p>
          </blockquote><p></p>` : ''
        }, {
            resourceSectionId: payload.meta.resourceSectionId,
            documentSectionId: payload.meta.documentSectionId,
            private: payload.meta.private
        });
        // This is done to optimistically update the local state for sub tasks list.
        if (updateLocalState) {
            updateLocalState(response);
        }
        taskCollection.push([
            response
        ]);
        yield put(updateDocTaskIdNameMap({
            documentId: payload.documentId,
            projectId: payload.projectId,
            resourceSectionId: payload.meta.resourceSectionId,
            resourceObjects: [
                apiToNormalized(response)
            ]
        }));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
    // TODO: handle error
    }
}
export const watchCreateDocSectionTasks = function*() {
    yield takeLatest(createDocSectionTask.type, createDocSectionTaskManager);
};
